import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

export default function AzubiMultiSelect({azubis, selectedAzubis, handleSelect, placeholder, onMenuOpen, onMenuClose}) {
  const style = {
    control: base => ({
      ...base,
      boxShadow: 'none',
    }),
  }
  return (
    <div data-testid="azubiMultiSelect" className="azubiMultiSelect-wrapper">
      <Select
        isMulti
        options={azubis}
        value={selectedAzubis}
        className="azubiMultiSelect"
        classNamePrefix="azubiMultiSelect"
        onChange={handleSelect}
        placeholder={placeholder}
        getOptionLabel={v => v.name}
        getOptionValue={v => v.id}
        closeMenuOnSelect={false}
        isSearchable={false}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        styles={style}
      />
    </div>
  )
}

AzubiMultiSelect.propTypes = {
  selectedAzubis: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  handleSelect: PropTypes.func.isRequired,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
  azubis: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  placeholder: PropTypes.string,
}
